module.exports = __webpack_public_path__ + "assets/img/btn-download-xbox-9e1b6690.png";